if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType;

        this.cartNotification = document.querySelector("cart-notification");

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);

        this.error = false;
        this.lastAddedVariantId = null;
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage &&
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Store variant id so we can highlight the correct item in the notification
        const variantId = formData.get("id");
        this.lastAddedVariantId = variantId ? Number(variantId) : null;

        // ⬇️ Build sections list: existing cart sections + cart-notification
        let sectionsToRender = [];
        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          sectionsToRender = this.cart
            .getSectionsToRender()
            .map((section) => section.id);
        }
        sectionsToRender.push("cart-notification");

        formData.append("sections", sectionsToRender);
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              // if there is no cart drawer at all, fallback to cart page
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cartType === "page") {
              // ✅ Always stop loading spinner
              this.disableLoadingInButton();

              // ✅ Re-enable button if there was no error
              if (!this.error) {
                this.submitButton.removeAttribute("aria-disabled");
              }

              return;
            }

            // drawer / other cart types
            this.disableLoadingInButton();
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (this.error) return;

            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            if (this.quick_add_container) {
              this.quick_add_product =
                this.quick_add_container.querySelector(".wt-product");
              this.loader = this.quick_add_container.querySelector(
                ".wt__quick-buy-loader",
              );

              if (
                !this.quick_add_container.classList.contains("hidden") &&
                this.quick_add_product &&
                this.loader
              ) {
                this.quick_add_product.remove();
                this.quick_add_container.classList.remove(
                  "wt__quick-buy__container--open",
                );
                this.quick_add_overlay?.classList.remove(
                  "wt__quick-buy--page-overlay--open",
                );
                document.body.classList.remove("quick-buy-page-overlay");
                this.loader.classList.remove("hidden");
              }
            }
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        const spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay?.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }

        // 👉 For non-drawer types: show cart-notification using HTML rendered by Liquid
        this.showCartNotification(response);
      }

      showCartNotification(response) {
        const sectionId = "cart-notification";

        const notificationRoot =
          this.cartNotification || document.querySelector("cart-notification");
        if (!notificationRoot) return;

        // Replace section HTML from Shopify response
        if (response && response.sections && response.sections[sectionId]) {
          const html = new DOMParser().parseFromString(
            response.sections[sectionId],
            "text/html",
          );

          const newSection =
            html.querySelector(`#shopify-section-${sectionId}`) ||
            html.body.firstElementChild;

          const currentSection = document.querySelector(
            `#shopify-section-${sectionId}`,
          );

          if (newSection && currentSection) {
            currentSection.innerHTML = newSection.innerHTML;
          } else if (newSection && !currentSection) {
            // Fallback: if section wrapper isn't found, update the cart-notification element directly
            const newCartNotification = newSection.querySelector(
              "cart-notification",
            );
            if (newCartNotification) {
              notificationRoot.innerHTML = newCartNotification.innerHTML;
            }
          }
        }

        // Re-select after replacement
        const updatedNotificationRoot =
          document.querySelector("cart-notification") || notificationRoot;

        // 👉 Pick the correct item by variant id (last added)
        if (this.lastAddedVariantId) {
          const items = updatedNotificationRoot.querySelectorAll(
            ".cart-notification__item",
          );
          let matched = false;

          items.forEach((el) => {
            const variantId = Number(el.dataset.variantId);
            if (!matched && variantId === this.lastAddedVariantId) {
              el.style.display = "";
              matched = true;
            } else {
              el.style.display = "none";
            }
          });
        }

        this.bindCartNotificationEvents(updatedNotificationRoot);
        updatedNotificationRoot.classList.add("active");
        document.querySelector("body").classList.add("page-overlay-cart-on");
      }

      bindCartNotificationEvents(notificationRoot) {
        if (!notificationRoot) return;

        // Close when clicking backdrop
        if (!notificationRoot.dataset.cartNotificationOverlayBound) {
          notificationRoot.addEventListener("click", (e) => {
            if (e.target === notificationRoot) {
              notificationRoot.classList.remove("active");
              document.querySelector("body").classList.remove("page-overlay-cart-on");
            }
          });
          notificationRoot.dataset.cartNotificationOverlayBound = "true";
        }

        // Close icon inside header
        const closeIcon = notificationRoot.querySelector(
          "#cart-notification__close",
        );

        if (closeIcon && !closeIcon.dataset.cartNotificationBound) {
          closeIcon.addEventListener("click", (e) => {
            e.preventDefault();
            notificationRoot.classList.remove("active");
            document.querySelector("body").classList.remove("page-overlay-cart-on");
          });
          closeIcon.dataset.cartNotificationBound = "true";
        }

        // "Continue shopping" text button
        const closeTextButton = notificationRoot.querySelector(
          "#cart-notification__close-text",
        );

        if (closeTextButton && !closeTextButton.dataset.cartNotificationBound) {
          closeTextButton.addEventListener("click", (e) => {
            e.preventDefault();
            notificationRoot.classList.remove("active");
            document.querySelector("body").classList.remove("page-overlay-cart-on");
          });
          closeTextButton.dataset.cartNotificationBound = "true";
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
